module.exports = __webpack_public_path__ + "static/media/icon-audience-inactived.3165c186.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/icon-audience-inactived.png
// module id = 1360
// module chunks = 0